<div class="input-group" [title]="field.key">
  <div>
    <div class="k-numerictextbox maximize-input">
      <span class="k-numeric-wrap">
        <input
          [id]="stringValueInputId"
          #box
          (change)="onStringValueChanged(box.value)"
          [(ngModel)]="stringValue"
          class="k-input"
          attr.maxlength="{{ stringValueLength }}"
          [class.textbox-invalid]="isValid === false"
        />
        <span class="k-select">
          <button class="k-button" (click)="isOpen = !isOpen" [attr.aria-label]="'action.open' | translate">
            <i
              class="k-icon"
              [class.k-i-arrow-s]="isOpen === false"
              [class.k-i-arrow-n]="isOpen === true"
              aria-hidden="true"
            ></i>
          </button>
        </span>
      </span>
    </div>
  </div>
</div>
<div class="range-field" *ngIf="isInitialized && isOpen">
  <table class="table table-borderless range">
    <tr>
      <td width="1" style="padding: 5px; font-weight: 700;">{{ 'components.rangeField.from' | translate }}</td>
      <td style="position: relative; width: 50px;">
        <select 
          id="minOperator"
          class="form-control"          
          style="position: absolute; top: 0; bottom: 0; padding: 0; height: 100%; border-right: none;"
          [(ngModel)]="minOperator"
          (ngModelChange)="onValuesChanged()">
          <option *ngFor="let item of operatorItems" [ngValue]="item">{{ item }}</option>
        </select>
      </td>
      <td>
        <kendo-numerictextbox
          [(ngModel)]="minValue"
          *ngIf="!hasRange"
          id="minValue"
          [autoCorrect]="'true'"
          [format]="'##.####'"
          [spinners]="false"
          (valueChange)="onValuesChanged()"
          style="width: 100%"
        >
        </kendo-numerictextbox>
      </td>
      <td *ngIf="hasUnits" style="position: relative; width: 105px;">
        <select 
          id="minUnit"
          class="form-control"          
          style="position: absolute; top: 0; bottom: 0; padding: 0; height: 100%; border-left: none;"
          [(ngModel)]="minUnitInternal"
          (ngModelChange)="onValuesChanged()">
          <option *ngFor="let item of unitItems" [ngValue]="item">{{ item }}</option>
        </select>
      </td>
    </tr>
    <tr style="margin-bottom: 20px" *ngIf="hasMaxValue">
      <td width="1" style="padding: 5px; font-weight: 700;">{{ 'components.rangeField.to' | translate }}</td>
      <td style="position: relative; width: 50px;">
        <select 
          id="maxOperator"
          class="form-control"          
          style="position: absolute; top: 0; bottom: 0; padding: 0; height: 100%; border-right: none;"
          [(ngModel)]="maxOperator"
          (ngModelChange)="onValuesChanged()">
          <option *ngFor="let item of operatorItems" [ngValue]="item">{{ item }}</option>
        </select>        
      </td>
      <td>
        <kendo-numerictextbox
          [(ngModel)]="maxValue"
          *ngIf="!hasRange"
          id="maxValue"
          [autoCorrect]="'true'"
          [format]="'##.####'"
          [spinners]="false"
          (valueChange)="onValuesChanged()"
          style="width: 100%"
        >
        </kendo-numerictextbox>
      </td>
      <td *ngIf="hasUnits" width="1" style="position: relative; width: 105px;">
        <select 
          id="maxUnit"
          class="form-control"          
          style="position: absolute; top: 0; bottom: 0; padding: 0; height: 100%; border-left: none;"
          [(ngModel)]="maxUnitInternal"
          (ngModelChange)="onValuesChanged()">
          <option *ngFor="let item of unitItems" [ngValue]="item">{{ item }}</option>
        </select>
      </td>
    </tr>
    <tr>
      <td width="1" style="padding: 5px">
        <label for="description">{{ 'components.rangeField.description' | translate }}</label>
      </td>
      <td [attr.colspan]="hasUnits ? 3 : 2" style="height: 100px; padding: 5px 0">
        <textarea
          [(ngModel)]="description"
          id="description"
          [ngClass]="{ filled: description?.length > 0 }"
          (change)="onValuesChanged()"
          class="form-control"
          attr.maxlength="{{ stringDescriptionLength }}"
          style="width: 100%; height: 100%; resize: none"
        ></textarea>
      </td>
    </tr>
    <tr *ngIf="plausibilityItems && plausibilityItems.length > 1">
      <td width="1" style="padding: 5px; font-weight: 700;">{{ 'components.rangeField.plausibility' | translate }}</td>
      <td [attr.colspan]="hasUnits ? 3 : 2">
        <select 
          id="plausibility"
          class="form-control"          
          [(ngModel)]="plausibility"
          (ngModelChange)="onValuesChanged()">
          <option *ngFor="let item of plausibilityItems" [ngValue]="item">{{ item }}</option>
        </select>
      </td>
    </tr>
  </table>
</div>
